import type { CSSProperties, ReactNode } from 'react';

import { Popover, PopoverContent, PopoverTrigger } from '@shared/components/ui';

interface GenericPopoverProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
  onEscapeKeyDown?: (e: globalThis.KeyboardEvent) => void;
  style?: CSSProperties;
}

export const GenericPopover = ({
  open,
  onOpenChange,
  trigger,
  children,
  contentClassName = '',
  align = 'center',
  sideOffset = 4,
  onEscapeKeyDown,
  style,
}: GenericPopoverProps) => (
  <Popover open={open} onOpenChange={onOpenChange}>
    <PopoverTrigger asChild>{trigger}</PopoverTrigger>
    <PopoverContent
      className={contentClassName}
      align={align}
      sideOffset={sideOffset}
      onEscapeKeyDown={onEscapeKeyDown}
      style={style}
    >
      {children}
    </PopoverContent>
  </Popover>
);
